export const navItems = [
  {
    label: 'Ecosystem',
    dropdown: [
      { label: 'Liquidity Providers', href: '/liquidity-providers' },
      { label: 'Mines', href: '/mines' },
      { label: 'Bullion Providers', href: '/bullion-providers' },
      { label: 'Industry Professionals', href: '/industry-professionals' }
    ]
  },
  {
    label: 'Reserve',
    dropdown: [
      { label: 'Reserve Architecture', href: '/reserve-architecture' },
      { label: 'Gold Reserve Data', href: '/reserve-data/azg' },
      { label: 'Silver Reserve Data', href: '/reserve-data/azs' }
    ]
  },
  { label: 'Reserve Room', href: '/reserve-room' },
  { label: 'Marketplace', href: '/btx' },
  { label: 'Get In Touch', isContact: true }
];

export const featureTiles = [
  {
    title: 'The Pathway',
    subtitle: 'A unified framework connecting miners and bullion providers within structured reserve infrastructure.'
  },
  {
    title: 'Asset Backed Security',
    subtitle: 'Every token exists within a structured reserve framework supported by reserve-linked assets and vaulted metal.'
  },
  {
    title: 'Transparent Reporting',
    subtitle: 'Live reserve data shows pledged, delivered, and vaulted assets for both parties.'
  },
  {
    title: 'Reserve-Grade Structure',
    subtitle: 'A compliant framework built for mines, bullion providers, and global financial partners.'
  }
];

export const layers = [
  {
    number: 1,
    title: 'In-ground resources',
    subtitle: 'Where value begins',
    bullets: [
      'We help you document and verify your mineral resources',
      'Present your project in a format financiers understand',
      'Independent geological validation builds credibility'
    ]
  },
  {
    number: 2,
    title: 'Funding & production',
    subtitle: 'Access to capital',
    bullets: [
      'A portion of your verified resources is used to build a funding model',
      'You are introduced to liquidity partners who can provide capital',
      'Ongoing production strengthens your position over time'
    ]
  },
  {
    number: 3,
    title: 'Vaulted bullion',
    subtitle: 'Long-term strength',
    bullets: [
      'Refined metal stored within secure institutional vault infrastructure.',
      'Becomes the final asset base supporting your financial model',
      'Provides the foundation for long-term financing'
    ]
  }
];

export const whyItMatters = [
  'A funding pathway traditional banks do not offer',
  'You keep 100% ownership of your mining project',
  'Transparent, geologist-backed reporting',
  'Builds confidence with investors and partners',
  'A clear model mines can understand',
  'Backed by real vaults and verified partners'
];

export const reserveData = [
  {
    label: 'Total gold reserves',
    value: '12,847',
    unit: 'oz',
    liveFeed: true
  },
  {
    label: 'Total silver reserves',
    value: '284,392',
    unit: 'oz',
    liveFeed: true
  },
  {
    label: 'Total mineral volume',
    value: '1,847,293',
    unit: 'units',
    liveFeed: true
  },
  {
    label: 'Tokens in circulation',
    value: '8,429,184',
    unit: 'tokens',
    liveFeed: true
  },
  {
    label: 'Circulation / reserve backing',
    value: '94.3',
    unit: '%',
    liveFeed: true
  }
];

export const useCases = [
  {
    title: 'For Mines',
    bullets: [
      'Unlock new financing pathways',
      'Keep full ownership and control',
      'Build investor confidence with transparent reporting',
      'Simple, clear onboarding process'
    ],
    cta: 'How It Works for Mines',
    ctaLink: '/mines',
    image: 'mining'
  },
  {
    title: 'For Bullion Providers',
    bullets: [
      'Access a transparent model backed by real metal',
      'Clear documentation and audit trails',
      'Reserve-grade reporting and compliance',
      'Understand the full metal lifecycle'
    ],
    cta: 'How it works for Bullion Providers',
    ctaLink: '/reserve-architecture',
    image: 'institutional'
  },
  {
    title: 'For Partners & Introducers',
    bullets: [
      'Commercial partnership opportunities',
      'Simple referral processes',
      'Support mines in accessing financing',
      'Join a growing trusted network'
    ],
    cta: 'Partner With Us',
    ctaLink: '/reserve-architecture',
    image: 'partners'
  }
];

export const ecosystemCards = [
  {
    title: 'Mines',
    description: 'You bring verified resources and production.',
    bullets: [
      'Gold, silver, and mineral projects',
      'From exploration to established operations',
      'Full support through the financing journey'
    ],
    partners: 8
  },
  {
    title: 'Geological & Technical Partners',
    description: 'Independent experts verify the project and reporting.',
    bullets: [
      'Geological validation and assay services',
      'Third-party audit and compliance',
      'Technical reporting and documentation'
    ],
    partners: 12
  },
  {
    title: 'Liquidity & Financial Partners',
    description: 'Global bullion providers and partners provide financing pathways.',
    bullets: [
      'Investment funds and financing partners',
      'Liquidity providers and lenders',
      'Secure vault operators and custodians'
    ],
    partners: 15
  }
];

export const learningTopics = [
  'How mine financing works with Arizore',
  'How resources move from ground to vault',
  'Why transparency matters for funding',
  'Understanding geological validation',
  'How vaulted bullion provides backing'
];

export const companyTopics = [
  'About Arizore',
  'Governance structure',
  'Leadership team',
  'Legal & compliance',
  'Careers'
];

export const footerLinks = {
  Ecosystem: [
    { label: 'Liquidity Providers', href: '/liquidity-providers' },
    { label: 'Mines', href: '/mines' },
    { label: 'Bullion Providers', href: '/bullion-providers' },
    { label: 'Industry Professionals', href: '/industry-professionals' }
  ],
  Reserve: [
    { label: 'Reserve Architecture', href: '/reserve-architecture' },
    { label: 'Gold Reserve Data', href: '/reserve-data/azg' },
    { label: 'Silver Reserve Data', href: '/reserve-data/azs' }
  ],
  'Reserve Room': [
    { label: 'Podcast', href: '/reserve-room' },
    { label: 'Insights', href: '/reserve-room' }
  ],
  Marketplace: [
    { label: 'BTX Marketplace', href: '/btx' }
  ],
  Company: [
    { label: 'Leadership', href: '/company' },
    { label: 'Get In Touch', href: '#' },
    { label: 'Become an Introducer', href: 'https://differentiaform.fillout.com/t/87U26Pcw8qus', external: true },
    { label: 'Legal', href: '/terms-of-service' }
  ]
};